// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/index.less
// module id = 1628
// module chunks = 0